import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { NotifierService } from 'angular-notifier';
import { environment } from "src/environments/environment";
import { QualApiService } from './qual-api.service';
import { Router } from '@angular/router';
import {ReportService,  ReportDetails } from 'src/app/repository/service/report.service';
import { ApiRequestService } from 'src/app/services/api-request/api-request.service';

@Injectable({
  providedIn: 'root'
})
export class QualService {

  public QUAL_REQUEST = environment.apiUrl + '/v2/api/';
  public httpPostOptions = {
    headers: new HttpHeaders().set('Content-Type', 'application/json'),
    withCredentials: true,
    params:{}
  };

  public isOpenInvite:boolean = false;
  public interviewUuid:string = '';

  public inviteList:any = [];
  public invitingEmails = [];
  public suggestedEmails = '';
  public showSuggestion:boolean = false;

  public isOpen: boolean = false;
  // public isInsight: boolean = false;
  public isDisableBtn: boolean = false;
  // public isOpen: boolean = true;
  public searchText:string = "";
  public interviewData: any[];
  public selectedInterview: any;
  public interviewDetails: any;
  public isLoading: boolean = false;
  public studyId:string = '';
  public studyName:string = '';
  public sidenav2Open: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private http:HttpClient, public QAService:QualApiService, private notifier: NotifierService,private router:Router,public reportService:ReportService,private apiRequest: ApiRequestService) { 
    this.sidenav2Open.subscribe((value) => { this.isOpen = value; });
    this.getStudyId();
    // this.studyId = "";
  }

  getStudyId(){
    this.studyId = this.router.url.split('/')[this.router.url.split('/').length - 1];
    // if (localStorage.getItem('studyId')) {
    //   localStorage.setItem('studyId',this.studyId);
    // }

    if (sessionStorage.getItem('studyId')) {
      sessionStorage.setItem('studyId',this.studyId);
    }
  }
  
  getInterviewList(){
    this.getStudyId();
    let body = {"study_id":this.studyId};
    this.isLoading = true;
    this.QAService.getInterviewList(body)
    .subscribe(result =>{
      if (result["status"] == 1) {
        this.studyName = result["name"];
        this.interviewData = result["data"];
        this.isLoading = false;
      }else if(result["status"] == 0){
        this.notifier.notify('error',result["message"]);
        // this.notifier.notify('error','Something went wrong.');
        this.isLoading = false;
      }else{
        // console.log("result status ===> ",result.status)
        this.isLoading = false;
      }
    })

  }

  getInterviewDetails(){
    this.getStudyId();
    let body = {"study_id":this.studyId};
    this.QAService.getInterviewDetails(body)
    .subscribe(result =>{
      if (result["status"] == 1) {
        this.interviewDetails = result["data"];
        this.reportService.reportDetails.title = this.interviewDetails.title;
        this.reportService.reportDetails.description = this.interviewDetails.description;
        this.reportService.reportDetails.source = this.interviewDetails.source;
        this.reportService.reportDetails.uploaded_by = this.interviewDetails.uploaded_by;
        if (this.interviewDetails.study_summary) {
          this.reportService.reportDetails.study_summary = this.interviewDetails.study_summary;
          this.reportService.checkStudySummaryVisibility(this.reportService.reportDetails)
        }
        
        // this.reportService.reportDetails.interviews = this.interviewDetails['interviews'];
        this.isLoading = false;
        this.reportService.isLoading = false;
        this.interviewDetails['interviews'].forEach(item =>{
          if(item['files'] && item['files'].length > 0){
          
            item['files'].map(file => {
              let myString = file['resource'];
              const ext = myString.substring(myString.lastIndexOf(".") + 1);
              file['type'] = ext;
              // file['uuid'] = this.uuid;
              if(file['file_type']){
                file['file_type'] = this.reportService.formatFileType(file['file_type']);
              }
            })
          }
        })

        // console.log("this.interviewDetails['interviews'] ===> ",this.interviewDetails['interviews'])
        //voc object format
        this.reportService.formatVocQual(this.interviewDetails,true);

        // this.reportService.reportDetails.interviews.forEach(item =>{
        //   if(item['files'] && item['files'].length > 0){
          
        //     item['files'].map(file => {
        //       let myString = file['resource'];
        //       const ext = myString.substring(myString.lastIndexOf(".") + 1);
        //       file['type'] = ext;
        //       // file['uuid'] = this.uuid;
        //     })
        //   }
        // })

        if (this.selectedInterview && this.selectedInterview.name  && this.selectedInterview.name !='') {
          this.onSearchChange(this.selectedInterview.name);
          // this.reportService.reportDetails.interviews = this.interviewDetails['interviews'].filter((item) =>{return item.name == this.selectedInterview.name});
        }else{
          this.onSearchChange('');
        }
      }else{
        this.isLoading = false;
        this.reportService.isLoading = false;
        this.notifier.notify('error','Something went wrong.');
      }
    })
  }

  formatFileType(file_type){
    switch(file_type){
      case "report" : file_type = 'Report';
      break;
      case "questionnaire" : file_type = 'Questionnaire';
      break;
      case "dataTable-abs" : file_type = 'Data Table - ABS';
      break;
      case "Data Table - ABS" : file_type = 'dataTable-abs';
      break;
      case "dataTable-pct" : file_type = 'Data Table - PCT';
      break;
      case "Data Table - PCT" : file_type = 'dataTable-pct';
      break;
      case "image" : file_type = 'Image';
      break;
      case "video" : file_type = 'Video';
      break;
      case "kpiViewer" : file_type = 'Topline Report';
      break;
      case "Topline Report" : file_type = 'kpiViewer';
      break;
      case "audio" : file_type = 'Audio';
      break;
      default:file_type = 'None';
      break;
    }
    return file_type;
  }

  onSearchChange(value){
    this.searchText = value;
    this.reportService.reportDetails.interviews = this.interviewDetails['interviews'].filter((item) =>{return item.name && item.name.toLowerCase().includes(this.searchText.toLowerCase())});
    // console.log("this.reportService.reportDetails.interviews ===> ",this.reportService.reportDetails.interviews)
  }

  inviteUser(data): Observable<any>{
    return this.apiRequest.request('POST',"/v2/api/inviteNewPeople",data);
  }

  // openInsight(){
  //   this.isInsight = true;
  // }

  // close(){
  //     this.isInsight = false;
  // }

}
